import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Cryptr from 'cryptr'
export default class AuthForm extends Component {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    authHbUserDone: PropTypes.func.isRequired
  }
  state = {
    iframe: false,
    pwd: void 0
  }
  componentDidMount() {
    if (this.state.iframe && this.state.pwd) {
      this.refs.auth_form.submit()
    }
  }
  componentWillMount() {
    const { currentUser } = this.props
    if (
      currentUser.hiboutikAccount &&
      currentUser.user_email &&
      currentUser.pwdHash
    ) {
      this.setState({
        iframe: true,
        pwd: new Cryptr('client').decrypt(currentUser.pwdHash)
      })
    }
  }
  handleLoaded = e => {
    this.setState({ iframe: false, pwd: '' })
    this.props.authHbUserDone()
  }
  render() {
    const { currentUser } = this.props
    const { pwd, iframe } = this.state
    return (
      <div>
        <form
          ref="auth_form"
          method="post"
          action={`https://${currentUser.hiboutikAccount}.hiboutik.com`}
          target="authIframe">
          <input type="hidden" name="action" value="identif_vendor" />
          <input type="hidden" name="auth_checked_user_mdp" value="1" />
          <input type="hidden" name="interface_boutique" value="classique" />
          <input type="hidden" name="langue_boutique" value="fr" />
          <input type="hidden" name="local_print_checked" value="1" />
          <input type="hidden" name="code_boutique" value="1" />
          <input
            type="hidden"
            name="login_user"
            value={currentUser.user_email}
          />
          <input type="hidden" name="pass_user" value={pwd} />
        </form>
        {iframe && (
          <iframe
            title="authForm"
            onLoad={this.handleLoaded}
            ref="authIframe"
            name="authIframe"
            style={{ display: 'none' }}
          />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/hiboutikForms/AuthForm.js